import { type ReactNode, useRef } from "react";
import { useScrollFade } from "@/components/shared/useScrollFade";

export function HorizontalShelf({ children }: { children: ReactNode }) {
    const ref = useRef<HTMLDivElement>(null);
    useScrollFade(ref);
    return (
        <div
            ref={ref}
            // oxlint-disable-next-line shadcn/no-arbitrary-values -- bleed and inset read the --content-px variable, which no spacing step exposes
            className="scroll-fade-x -mx-[var(--content-px,1.5rem)] flex snap-x snap-mandatory gap-4 overflow-x-auto overscroll-x-contain scrollbar-none py-4 pl-[var(--content-px,1.5rem)] scroll-pl-[var(--content-px,1.5rem)] md:snap-none"
        >
            {children}
            <div
                aria-hidden
                // oxlint-disable-next-line shadcn/no-arbitrary-values -- trailing spacer matches the runtime content rail width
                className="w-[var(--content-px,1.5rem)] shrink-0"
            />
        </div>
    );
}
